function uuid(){
	const s = `${new Date().getTime()}`.slice(8)
	const O1 = () =>
		(((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
	return `${s}_${O1()}_${O1()}_${O1()}`
}

export default uuid